import { Collapse, createStyles, Grid, TextField, Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'
import { mapToYesOrNoWithNullable } from '../../../services/utils'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'

interface AcademicAwardDetailsProps extends WithStyles<typeof styles> {
	earnedDegreeOrCredit?: boolean | null
	academicCredit: string
	creditsEarned: number | string
	handleEarnedDegreeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleTypeofCreditChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleCreditsEarnedChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const AcademicCreditDetails: React.FC<AcademicAwardDetailsProps> = (props: AcademicAwardDetailsProps) => {
	const {
		classes,
		earnedDegreeOrCredit,
		handleEarnedDegreeChange,
		handleTypeofCreditChange,
		academicCredit,
		creditsEarned,
		handleCreditsEarnedChange,
	} = props

	return (
		<div className={classes.root}>
			<Typography variant="h5" className={classes.sectionSubtitle}>
				Credit and Credentials
			</Typography>

			<Grid container={true} spacing={8}>
				<Grid item={true} xs={12}>
					<OutcomeDropDownItem
						label="Earned Academic Degree/Credit"
						prop="earnedDegreeOrCredit"
						value={mapToYesOrNoWithNullable(earnedDegreeOrCredit)}
						onInputChange={handleEarnedDegreeChange}
						items={['Yes', 'No']}
					/>
				</Grid>
			</Grid>
			<Collapse
				in={!!earnedDegreeOrCredit}
				style={{ transformOrigin: '0 0 0', flexGrow: 1 }}
				{...(earnedDegreeOrCredit ? { timeout: 750 } : {})}
			>
				<Grid container={true} spacing={8}>
					<Grid item={true} xs={12}>
						<OutcomeDropDownItem
							label="Type of credit"
							prop="academicCredit"
							value={academicCredit}
							onInputChange={handleTypeofCreditChange}
							items={['High School Credit', 'College Credit']}
						/>
					</Grid>
					<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
						Number of credits&#58;
					</Grid>
					<Grid item={true} xs={12} sm={3}>
						<TextField
							name="creditsEarned"
							className={classes.dropdown}
							value={creditsEarned}
							onChange={handleCreditsEarnedChange}
							margin="dense"
							variant="outlined"
							InputProps={{
								inputProps: {
									type: 'number',
									min: '0',
									step: 'any',
								},
							}}
						/>
					</Grid>
					<Grid item={true} xs={false} sm={6} />
				</Grid>
			</Collapse>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},

		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},

		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
	})

export default withStyles(styles)(AcademicCreditDetails)
